import Header from "../../components/Header/Header"

export default function Layout(props) {
    const { handleHome, 
            handleSkills, 
            handleProjects, 
            handleContact,
            isMenuOpen, 
            handleMenu } = props;
    return (
        <>
            <Header handleHome={handleHome} 
                    handleSkills={handleSkills} 
                    handleProjects={handleProjects} 
                    handleContact={handleContact}
                    isMenuOpen={isMenuOpen}
                    handleMenu={handleMenu}
                    ></Header>
            {props.children}
            
        </>
    )
}